import { Skeleton } from "@mui/material";
import { GhostProps } from "../../interfaces/props/GhostProps";
import StringHelper from "../../helpers/string.helper";
import { GhostTemplates } from "../../enums/GhostTemplates";
import ArticleCard from "./templates/ArticleCard";
import React, { useMemo } from "react";
import VariationCard from "./templates/VariationCard";
import TipCard from "./templates/TipCard";

const templateMapper: Record<GhostTemplates, React.ElementType> = {
  [GhostTemplates.ARTICLE_CARD]: ArticleCard,
  [GhostTemplates.VARIATION_CARD]: VariationCard,
  [GhostTemplates.TIP_CARD]: TipCard,
};

const Ghost = ({ className, repeatValue, template }: GhostProps) => {
  const ghostClassName = className ? `${className} ghost` : 'ghost';
  const TemplateComponent = useMemo(() => {
    return template ? templateMapper[template] : () => <Skeleton variant='rounded' width='100%' classes={{ root: ghostClassName }} />
  }, [template, ghostClassName]);

  return <>
    {
      repeatValue ?
        Array.from({ length: repeatValue }).map(() => (
          <TemplateComponent key={StringHelper.generateRandomString(8)} />
        ))
        :
        <TemplateComponent />
    }
  </>
};

export default Ghost;
